import Vue from "vue";
import Vuex from "vuex";
import {
  queryMyselfInfo
} from "@/services/user/index.js";
// import {
//   queryMyselfStore
// } from "@/services/mall/store.js";
//1. 安装
Vue.use(Vuex);
var store = new Vuex.Store({
  state: {
    //TODO:登录后的token,1天失效
    storeToken: "",
    //用户信息: 导航权限 店铺权限
    userInfo: {},
    //全量导航  routerName: "Management"
    navList: [
      //系统管理
      {
        id: "0",
        label: "超级管理员",
        icon: "el-icon-setting",
        routerName: "system",
        disabled: true,
        children: [{
          id: "0-1",
          label: "账号管理",
          routerName: "SysUser",
          path: "/management/system/user",
          disabled: true,
        },
        {
          id: "0-2",
          label: "角色管理",
          routerName: "AuthGroup",
          path: "/management/system/authGroup",
          disabled: true,
        },
        ],
      },

      /* 系统管理 */
      {
        id: "1",
        label: "系统管理",
        icon: "el-icon-setting",
        routerName: "MyPermission",
        children: [
          {
            id: "1-1",
            label: "账号管理",
            routerName: "MyPermissionUser",
            path: "/management/myPermission/user",
            //        routerName: "MallAdmin",
            // path: "/management/mall/admin",
          },
          {
            id: "1-2",
            label: "角色管理",
            routerName: "MyPermissionAuthGroup",
            path: "/management/myPermission/authGroup",
          },
        ],
      },


      //小程序管理
      {
        id: "2",
        label: "小程序管理",
        // icon: "el-icon-s-data",
        icon: "el-icon-s-platform",
        // icon: "el-icon-s-shop",
        routerName: "MiniApp",
        children: [
          {
            id: "2-1",
            label: "数据看版",
            routerName: "Dashboard",
            path: "/management/miniApp/dashboard",
          },
          {
            id: "2-2",
            label: "用户数据",
            routerName: "MallUser",
            path: "/management/miniApp/user",
          },
          // {
          //   id: "2-3",
          //   label: "轮播图管理",
          //   routerName: "MiniAppBanner",
          //   path: "/management/miniApp/banner",
          // },
          {
            id: "2-4",
            label: "公众号文章配置",
            routerName: "MiniAppArticle",
            path: "/management/miniApp/article",
          },
        ],
      },

      {
        id: "3",
        label: "信息概览管理",
        // icon: "el-icon-s-data",
        icon: "el-icon-s-platform",
        // icon: "el-icon-s-shop",
        routerName: "Information",
        children: [
          {
            id: "3-0",
            label: "医院管理",
            icon: "el-icon-s-order",
            routerName: "Hospital",
            path: "/management/information/hospital",
          },
          //  {
          //   id: "3-2",
          //   label: "医生信息",
          //   routerName: "MallGoods",
          //   children: [
          //     {
          //       id: "3-2-1",
          //       label: "科室分类",
          //       routerName: "MallGoodsKind",
          //       path: "/management/store/mallGoods/goodsKind",
          //     },
          //     {
          //       id: "3-2-2",
          //       label: "医生列表与出诊",
          //       routerName: "MallGoodsList",
          //       path: "/management/store/mallGoods/goodsList",
          //     },
          //   ],
          // },
          {
            id: "3-1",
            label: "医生出诊信息维护",
            icon: "el-icon-s-order",
            routerName: "InformationList",
            path: "/management/information/list",
          },
          {
            id: "3-2",
            label: "挂号预约记录",
            icon: "el-icon-s-order",
            routerName: "InformationReservation",
            path: "/management/information/reservation",
          },
        ],
      },

      {
        id: "6",
        label: "AI问诊",
        icon: "el-icon-upload",
        routerName: "AiService",
        children: [
          {
            id: "6-0",
            label: "问诊中心", //包含语音输入，病历拉取，生成
            icon: "el-icon-s-order",
            routerName: "ConsultationControl",
            path: "/management/aiService/consultationControl",
          },
          {
            id: "6-1",
            label: "问诊记录", //包含语音输入，病历拉取，生成
            icon: "el-icon-s-order",
            routerName: "AiAnswersRecord",
            path: "/management/aiService/answersRecord",
          },
          {
            id: "6-2",
            label: "病历管理", //修正
            icon: "el-icon-s-order",
            routerName: "AiArchives",
            path: "/management/aiService/archives",
          },

        ],
      },

      {
        id: "15",
        label: "提示词管理",
        icon: "el-icon-s-comment",
        routerName: "PromptService",
        children: [
          {
            id: "15-1",
            label: "问答配置-问诊AI",
            routerName: "PromptQuestions_one",
            path: "/management/promptService/questions_one",
          },
          {
            id: "15-3",
            label: "问答配置-科普AI",
            routerName: "PromptQuestions_two",
            path: "/management/promptService/questions_two",
          },
          {
            id: "15-4",
            label: "问答配置-预约AI",
            routerName: "PromptQuestions_three",
            path: "/management/promptService/questions_three",
          },
          {
            id: "15-2",
            label: "病历参数模版配置",
            routerName: "PromptArchives",
            path: "/management/promptService/archives",
          },
        ],
      },

      {
        id: "14",
        label: "微信通知服务",
        icon: "el-icon-s-comment",
        routerName: "SendService",
        children: [
          {
            id: "14-1",
            label: "公众号账户",
            routerName: "SendAccount",
            path: "/management/sendService/sendAccount",
          },

          {
            id: "14-2",
            label: "发送模版配置",
            routerName: "SendTemplate",
            path: "/management/sendService/sendTemplate",
          },
          {
            id: "14-3",
            label: "创建发送任务",
            routerName: "SendTouserAuto",
            path: "/management/sendService/sendTouserAuto",
          },
          {
            id: "14-4",
            label: "发送记录",
            routerName: "SendRecord",
            path: "/management/sendService/sendRecord",
          },
        ],
      },
      {
        id: "16",
        label: "api余量管理",
        icon: "el-icon-star-off",
        routerName: "MallVipCard",
        path: "/management/vipCard",
        children: [{
          id: "16-1",
          label: "财务账户列表",
          routerName: "MallVipCardList",
          path: "/management/vipCard/vipCardList",
          // disabled: true,
        },
        {
          id: "16-2",
          label: "交易记录",
          routerName: "MallVipCardRecode",
          path: "/management/vipCard/vipCardRecode",
        },
        {
          id: "16-3",
          label: "我的财务账户",
          routerName: "MallMyAccount",
          path: "/management/vipCard/myAccount",
        },
        ],
      },
      {
        id: "4",
        label: "api接口文档",
        icon: "el-icon-s-operation",
        routerName: "Doc",
        children: [{
          id: "4-1",
          label: "随访通知api",
          routerName: "DocGoods",
          path: "/management/doc/goods",
        },],
      },

      //个人页
      {
        id: "5",
        label: "个人页",
        icon: "el-icon-s-custom",
        routerName: "Person",
        children: [{
          id: "5-1",
          label: "个人中心",
          routerName: "PersonCenter",
          path: "/management/person/center",
        },],
      },
      // {
      //   id: "7",
      //   label: "商家服务",
      //   icon: "el-icon-s-comment",
      //   routerName: "Examine",
      //   children: [
      //     {
      //       id: "7-1",
      //       label: "续费",
      //       routerName: "Payment",
      //       path: "/management/merchant/payment",
      //     },

      //     {
      //       id: "7-2",
      //       label: "使用指南",
      //       routerName: "",
      //       path: "",
      //     },
      //     {
      //       id: "7-3",
      //       label: "技术支持",
      //       routerName: "",
      //       path: "",
      //     },
      //   ],
      // },
    ],
    //登录后筛选的导航
    filterNavList: [],
    //登录后筛选的店铺列表
    filterStoreList: [],
    //高亮导航项
    active: "",
  },
  //变更状态
  mutations: {
    updataUserInfo(state, value) {
      state.userInfo = value;
    },
    updataFilterNavList(state, value) {
      state.filterNavList = value;
    },
    updataFilterStoreList(state, value) {
      state.filterStoreList = value;
    },
    updataActive(state, value) {
      state.active = value;
    },
  },
  actions: {
    /* 用户信息权限,店铺信息初始化 */
    async getUserInfoAction({
      commit,
      state,
      dispatch
    }) {
      const resp = await queryMyselfInfo();
      const userInfo = resp?.result?.userInfo || {};
      // 添加租户名称到用户信息中
      userInfo.tenantName = resp?.result?.tenantName || '';
      commit("updataUserInfo", userInfo);

      // const storeList = await queryMyselfStore({
      //   store_id: userInfo.data.store_id || "",
      // });

      // commit("updataFilterStoreList", storeList.data);

      // 用户权限：后端未返回 rules 时，默认放开全部模块
      let rulesString = state.userInfo.rules;
      if (!rulesString) {
        rulesString = state.navList.map(item => item.id).join(",");
      }

      //根据用户权限初始化导航数据
      var copyNavList = JSON.parse(JSON.stringify(state.navList));
      var roleList = rulesString?.split(",");

      // console.log("copyNavList", copyNavList, "roleList======", roleList);
      await dispatch("getFilterNavListAction", {
        copyNavList,
        roleList,
      });
      commit("updataFilterNavList", copyNavList); //根据用户权限完成导航筛选

      /* 定位第一个导航 */
      const routerName = await dispatch("findFirstRouterName", copyNavList);
      return new Promise((reslove, reject) => {
        reslove({
          code: 200,
          routerName,
        });
      });
    },

    /* 导航筛选 */
    async getFilterNavListAction({
      dispatch,
      commit
    }, {
      copyNavList,
      roleList
    }) {
      for (var index = copyNavList.length - 1; index >= 0; index--) {
        if (
          copyNavList[index]?.children &&
          copyNavList[index]?.children.length > 0 &&
          roleList?.indexOf(copyNavList[index].id) >= 0
        ) {
          await dispatch("getFilterNavListAction", {
            copyNavList: copyNavList[index].children,
            roleList: roleList,
          });
        }
        if (roleList?.indexOf(copyNavList[index]?.id) < 0) {
          copyNavList.splice(index, 1);
        }
      }
    },

    /*  找到第一个导航最深层routerName */
    async findFirstRouterName({
      dispatch,
      commit
    }, copyNavList) {
      if (copyNavList[0]?.children && copyNavList[0]?.children.length > 0) {
        return await dispatch("findFirstRouterName", copyNavList[0]?.children);
      } else {
        return copyNavList[0].routerName;
      }
    },

    /* 找到导航active */
    async findActive({
      dispatch,
      commit
    }, {
      filterNavList,
      path
    }) {
      for (let index = 0; index < filterNavList.length; index++) {
        if (filterNavList[index]?.path === path) {
          commit("updataActive", filterNavList[index]?.id);
        }
        if (
          filterNavList[index]?.children &&
          filterNavList[index]?.children.length > 0 &&
          filterNavList[index]?.path !== path
        ) {
          await dispatch("findActive", {
            filterNavList: filterNavList[index]?.children,
            path,
          });
        }
      }
    },
  },

  /* 计算属性 */
  getters: {},
});
export default store;